import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import Navbar from "./Pages/Admin/Navbar";
import Header from "./common/Header";
const Dashboard = lazy(() => import('./Pages/Admin/Dashboard'));
const RegisteredUser = lazy(() => import('./Pages/Admin/RegisteredUsers'))
const AddUser = lazy(() => import('./Pages/Admin/AddUser'))
const PurchaseDashboard = lazy(() => import('./Pages/purchase/PurchaseDashboard'))
const DispatchDevice = lazy(() => import('./Pages/purchase/DispatchDevice'))
const AdminPlant = lazy(() => import('./Pages/Admin/AdminPlant'))
const UserDashboard = lazy (() => import('./Pages/User/UserDashboard'))
const UserPlant = lazy(() => import ('./Pages/User/UserPlant'))
const UserDetails = lazy(() => import('./Pages/User/UserDetails'))
const PurchasePlant = lazy(() => import('./Pages/purchase/PurchasePlant'))
const Test = lazy(() => import('./Test'))
const UserServerInfo = lazy(() => import('./Pages/User/UserServerInfo'))
const MqttConnection = lazy(() => import ('./mqtt/MqttConnection'))
const ReadyforDispatch = lazy(() => import('./Pages/purchase/ReadyforDispatch'))
const DeviceSummary = lazy(() => import('./Pages/purchase/DeviceSummary'))
const ReturnReplacement = lazy (() => import('./Pages/purchase/ReturnReplacement'))
const DeployDevices = lazy(() => import('./Pages/User/DeployDevices'))
const ScrabDevices = lazy(() => import('./Pages/purchase/ScrabDevices'))
const ScrapDevicesList = lazy(() => import('./Pages/purchase/ScrapDevicesList'))
const Sessions = lazy(() => import('./Pages/Admin/Sessions'))
const ApiKeys = lazy(() => import('./Pages/Admin/ApiKeys'))
const RoleProtectedRoute = lazy(() => import('./utils/RoleProtectedRoute'))
const NotAuthorized = lazy(() => import ('./Pages/NotAuthorized'))
const Replacepage = lazy(() => import('./Pages/Replacepage'))
const SuperAdminDashboard = lazy(() => import('./Pages/SuperAdmin/SuperAdminDashboard'))
const SuperAdminRegisteredUsers = lazy (() => import ('./Pages/SuperAdmin/SuperAdminRegisteredUsers'))
const SuperAdminAddUser = lazy (() => import ('./Pages/SuperAdmin/SuperAdminAddUser'))
const SuperAdminPlant = lazy(() => import('./Pages/SuperAdmin/SuperAdminPlant'))
const SuperAdminSession = lazy(() => import('./Pages/SuperAdmin/SuperAdminSession'))
const SuperAdminApiKeys = lazy(() => import('./Pages/SuperAdmin/SuperAdminApiKeys'))
const SuperAdminMfaSetup = lazy(() => import('./Pages/SuperAdmin/SuperAdminMfaSetup'))
const MfaSetup = lazy(() => import('./Pages/Admin/MfaSetup'))
const PurchaseMfaSetup = lazy(() => import('./Pages/purchase/PurchaseMfaSetup'))
const UserMfaSetup = lazy(() => import('./Pages/User/UserMfaSetup'))
const UserSecureVault = lazy(() => import('./Pages/User/UserSecureVault'))
const FirstLoginMfaSetup = lazy(() => import('./Pages/FirstLoginMfaSetup'))
const FirstLoginGuide = lazy(() => import('./Pages/FirstLoginGuide'))

function App() {
  return (
    <>
    <Suspense fallback={<div className='text-center'><h4>Loading page...</h4></div>}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/first-login/mfa-setup" element={<FirstLoginMfaSetup />} />
        <Route path="/first-login-guide" element={<FirstLoginGuide />} />
        {/* super admin routes */}
        <Route
          path="/super-admin/dashboard"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminDashboard />
            </RoleProtectedRoute>
          }
        />
         <Route
          path="/super-admin/users"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminRegisteredUsers />
            </RoleProtectedRoute>
          }
        />
           <Route
          path="/super-admin/add-user"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminAddUser />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/super-admin/dashboard/:id"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminPlant />
            </RoleProtectedRoute>
          }
        />
         <Route
          path="/super-admin/sessions"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminSession />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/super-admin/api-keys"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminApiKeys />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/super-admin/mfa-setup"
          element={
            <RoleProtectedRoute allowRoles={["superadmin"]}>
              <SuperAdminMfaSetup />
            </RoleProtectedRoute>
          }
        />

        {/* admin pages routes */}
        <Route
          path="/admin-dashboard"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <Dashboard />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/registered-users"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <RegisteredUser />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/add-user"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <AddUser />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-dashboard/:id"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <AdminPlant />
            </RoleProtectedRoute>
          }
        />

        <Route
          path="/sessions"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <Sessions />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/api-keys"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <ApiKeys />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mfa-setup"
          element={
            <RoleProtectedRoute allowRoles={["admin"]}>
              <MfaSetup />
            </RoleProtectedRoute>
          }
        />
        {/* purchase page routes */}

        <Route
          path="/purchase-dashboard"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <PurchaseDashboard />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dispatch-device"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <DispatchDevice />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/ready-for-dispatch"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <ReadyforDispatch />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/device-summary"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <DeviceSummary />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:id"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <PurchasePlant />
            </RoleProtectedRoute>
          }
        />
      

        <Route
          path="/return-replacement"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <ReturnReplacement />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/scrap-devices"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <ScrabDevices />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/scrap-list"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <ScrapDevicesList />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/purchase-mfa-setup"
          element={
            <RoleProtectedRoute allowRoles={["purchase"]}>
              <PurchaseMfaSetup />
            </RoleProtectedRoute>
          }
        />

        {/* normal user routes */}
        <Route
          path="/user-dashboard"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <UserDashboard />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/user-dashboard/:id"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <UserPlant />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/user-dashboard/:id/:id"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <UserDetails />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/user-dashboard/:id/:id/:id"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <UserServerInfo />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/deploy-devices"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <DeployDevices />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/user-mfa-setup"
          element={
            <RoleProtectedRoute allowRoles={["user", "operator", "developer"]}>
              <UserMfaSetup />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/secure-vault"
          element={
            <RoleProtectedRoute allowRoles={["developer"]}>
              <UserSecureVault />
            </RoleProtectedRoute>
          }
        />
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route path="/test" element={<Test />} />
        <Route path="*" element={<Replacepage />} />
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
